import { useCallback } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { ButtonContainer, Submit } from 'libs/ui';
import { required, ErrorMsg, StyledField } from 'libs/form';
import { LK } from './lk';

const NaturalPersonFormForm = (props) => {
  const { initialValues, handleSubmit, submitting, error } = props;
  const { t } = useTranslation();

  const rightUpdate = user.haveRight('clients.update');
  const requiredField = useCallback(required(t), [t]);

  return (
    <form onSubmit={handleSubmit} autoComplete="new-password">
      <ErrorMsg theme="dark" message={error} />

      <StyledField validate={requiredField} type="text" label={t('form.ФИО')} name="name" placeholder={t('form.Иванов Иван Иванович')} />
      <StyledField type="date" label={t('form.Дата рождения')} name="birth_date" placeholder={t('form.08 11 2017')} className="shortfield" />
      <StyledField type="text" label={t('form.Паспорт')} name="passport" placeholder="04 05 990440" />
      <StyledField type="text" label={t('form.Кем выдан')} name="passport_issued_by" placeholder="Выдан УВД Приморского района г. Санкт-Петербург" />
      <StyledField type="date" label={t('form.Дата выдачи')} name="passport_when_issued" placeholder={t('form.08 11 2017')} className="shortfield" />
      <StyledField type="text" label={t('form.Код подразделения')} name="passport_department_code" placeholder="233 – 005" />
      {initialValues.id && <LK lk_login={initialValues.lk_login} />}
      {rightUpdate && (
        <ButtonContainer>
          <Submit disabled={submitting} />
        </ButtonContainer>
      )}
    </form>
  );
};

export const NaturalPersonForm = reduxForm({
  form: 'NaturalPersonForm',
})(NaturalPersonFormForm);
